import {Theme, ThemeSpec} from './types';

export const Themes: Record<Theme, ThemeSpec> = {
  [Theme.Funnels]: {
    cellBorders: `line`,
    cellBorderHover: `none`,
    cellFocusable: false,
    cellHeaderBorders: `column-group`,
    cellHeaderShadow: true,
    cellBackground: `row-stripe`,
    cellShape: `square`,
    rowGroups: false,
    justifyCellsWithinGroup: true,
  },
  [Theme.Retention]: {
    cellBorders: `gap`,
    cellBorderHover: `outline`,
    cellFocusable: true,
    cellHeaderBorders: `none`,
    cellHeaderShadow: false,
    cellBackground: `heatmap`,
    cellShape: `round`,
    rowGroups: false,
    justifyCellsWithinGroup: false,
  },
};
